import { ImageRecordMinimal, TireHotelRecordCustomer } from '@navio/nsdk';
import { cn } from 'noddi-ui-common';
import { NoddiBasicCard, NoddiCheckbox } from 'noddi-ui-web';
import { CarImage } from 'noddi-web';
import { CarCardMeta } from '../../../Common/CarCardMeta';

type CarCardProps = {
  title: string;
  image?: ImageRecordMinimal | null;
  make: string;
  description?: string;
  lastBookingDate?: string | null;
  upcomingBookingDate?: string | null;
  tireHotel?: TireHotelRecordCustomer | null;
  isSelected: boolean;
  action: () => void;
};

export const SelectCarInBookingCard = ({
  title,
  image,
  make,
  isSelected,
  description,
  lastBookingDate,
  upcomingBookingDate,
  tireHotel,
  action
}: CarCardProps) => {
  return (
    <NoddiBasicCard
      onClick={action}
      selected={isSelected}
      size='small'
      className={cn(
        'relative isolate flex min-h-21 items-center gap-4 overflow-hidden px-4 transition-all duration-200 ease-out',
        // Selected cards take the light brand tint, not the solid selected fill: the photo multiplies onto the card,
        // and a dark fill would swallow the car. The checkbox carries the selected state.
        isSelected && 'border-primary bg-card-light-background text-foreground'
      )}
    >
      <CarImage car={{ image, make }} alt='' size='bleed' />
      {/* The card is the toggle (aria-pressed), so the checkbox only shows the state. */}
      <div aria-hidden className='pointer-events-none relative'>
        <NoddiCheckbox checked={isSelected} tabIndex={-1} />
      </div>
      {/* Right padding keeps text off the car, which fills the card's right edge. */}
      <div className='relative flex min-w-0 flex-1 flex-col pr-28'>
        <span className='font-semibold'>{title}</span>
        {description && <span className='text-sm font-medium tracking-wide tabular-nums'>{description}</span>}
        <CarCardMeta
          isOnTireHotel={!!tireHotel}
          upcomingBookingDate={upcomingBookingDate}
          lastBookingDate={lastBookingDate}
        />
      </div>
    </NoddiBasicCard>
  );
};
